import type { FileRelation } from "@/models/file/file-relation.model"
import { defineStore } from "pinia"
import { ref, type Ref } from "vue"

export const useFileRelationStore = defineStore("fileRelationStore", () => {
  const fileRelations: Ref<FileRelation[]> = ref([])
  const readOnly = ref(false)
  const selectedFileRelation: Ref<FileRelation | null> = ref(null)

  function setFileRelations(newFileRelations: FileRelation[]) {
    fileRelations.value = newFileRelations
  }

  function setSelectedFileRelation(newSelectedFileRelation: FileRelation | null) {
    selectedFileRelation.value = newSelectedFileRelation
  }

  return {
    readOnly,
    fileRelations,
    selectedFileRelation,
    setFileRelations,
    setSelectedFileRelation
  }
})
